<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";
import store from "@/state/store";
import VueHtml2pdf from "vue-html2pdf";
export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    if (userType === 2 || userType === 3) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Travel Request",
    meta: [{ name: "description", content: appConfig.description }],
  },
  computed: {
    ...authComputed,
  },
  components: {
    Layout,
    PageHeader,
    VueHtml2pdf,
  },
  mounted() {
    this.fetchRequest();
  },
  methods: {
    fetchRequest() {
      let requestID = this.$route.params.travelAppID;
      const url = `${this.ROUTES.travelApplication}/${requestID}`;
      this.apiGet(url, "Get Travel Application").then((res) => {
        console.log(res.data, "data");
        let {
          application,
          breakdown,
          expenses,
          sector,
          location,
          countryCode,
          travellers,
          hotels,
          attachments,
          log,
        } = res.data;
        breakdown = breakdown.sort(
          (breakdownA, breakdownB) =>
            new Date(breakdownA.ta_breakdown_date) -
            new Date(breakdownB.ta_breakdown_date)
        );
        this.application = application;
        this.breakdowns = breakdown;
        this.expenses = expenses;
        this.sector = sector;
        this.location = location;
        this.countryCode = countryCode;
        this.travellers = travellers;
        this.hotels = hotels;
        this.attachments = attachments;
        this.log = log;

        this.travellers.forEach((traveller) => {
          if (traveller.ta_traveller_t7) this.staffTravellers.push(traveller);
          else this.nonStaffTravellers.push(traveller);
        });
      });
    },
    exportFile() {
      this.$refs.html2Pdf.generatePdf();
    },
    viewAttachment(attachment) {
      window.open(`${attachment.ta_attachment_doc}`);
    },
  },
  data() {
    return {
      title: "Travel Request",
      items: [
        {
          text: "IHUMANE",
        },
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Travel Request",
          active: true,
        },
      ],
      application: null,
      breakdowns: [],
      expenses: [],
      donor: null,
      t2Codes: [],
      log: [],
      sector: null,
      location: null,
      countryCode: null,
      travellers: [],
      hotels: [],
      attachments: [],
      nonStaffTravellers: [],
      staffTravellers: [],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-end mb-3">
      <b-button class="btn btn-danger mr-3" @click="exportFile">
        <i class="fa fa-file-pdf mr-2"></i> Export
      </b-button>

      <b-button
        class="btn btn-success"
        @click="$router.push({ name: 'travel-requests' })"
      >
        <i class="mdi mdi-plus mr-2"></i>
        Travel Requests
      </b-button>
    </div>
    <scale-loader v-if="apiBusy" />
    <div class="row" v-else>
      <div class="col-12" v-if="application">
        <div class="card">
          <div class="card-body">
            <div class="p-3 bg-light mb-4 d-flex justify-content-between">
              <div class="d-inline mb-0">
                <h5
                  class="font-size-14 mb-0"
                  v-if="application && application.travelapp_travel_cat === 1"
                >
                  Official Travel Authorization / Per Diem Form
                </h5>
                <h5 class="font-size-14 mb-0" v-else>
                  Personal Travel Authorization
                </h5>
              </div>
              <span class="d-inline mb-0">
                <small
                  v-if="application && application.travelapp_status === 0"
                  class="text-warning"
                >
                  Application Pending
                </small>
                <small
                  v-else-if="application && application.travelapp_status === 1"
                  class="text-success"
                >
                  Application Approved
                </small>
                <small
                  v-else-if="application && application.travelapp_status === 2"
                  class="text-danger"
                >
                  Application Declined
                </small>
              </span>
            </div>
            <div class="row">
              <div class="col-lg-8">
                <div class="form-group">
                  <label for="">
                    Purpose of Travel
                    <small class="text-muted">(Description)</small>
                  </label>
                  <p class="text-muted">
                    {{ application.travelapp_purpose }}
                  </p>
                </div>
                <div class="form-group">
                  <label for="">
                    Dates of Travel
                    <small class="text-muted">(TO & FRO)</small>
                  </label>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for=""> Start </label>
                        <p class="text-muted">
                          {{
                            new Date(
                              application.travelapp_start_date
                            ).toDateString()
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for=""> End </label>
                        <p class="text-muted">
                          {{
                            new Date(
                              application.travelapp_end_date
                            ).toDateString()
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div
                  class="form-group"
                  v-if="application && application.travelapp_travel_cat === 1"
                >
                  <label for="">Program / Charge Codes</label>
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="form-group">
                        <label class="" for="">
                          T1 <small class="text-muted">(Grant Code)</small>
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div class="form-group">
                        <span>
                          <!--                          {{ donor.donor_code }} ({{ donor.donor_description }})-->
                          {{ application.travelapp_t1_code }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="expenses.length">
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label for="">
                            T2 <small class="text-muted">(Expense)</small>
                          </label>
                        </div>
                      </div>
                      <div class="col-lg-8">
                        <div class="form-group">
                          <p
                            class="mb-0"
                            v-for="(t2code, index) in expenses"
                            :key="index"
                          >
                            <!--                            {{ t2code.expense }}: {{ t2code.code }}-->
                            {{ t2code.travelapp_t2_id }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row mb-4"
              v-if="application && application.travelapp_travel_cat === 1"
            >
              <div class="col-lg-12 mb-3">
                <label for="">Trip Type</label>
                <p class="m-0 text-uppercase">
                  {{ application.travelapp_trip_type || "N/A" }}
                </p>
              </div>
              <div class="col-lg-3">
                <label for="">
                  Sector Code <small class="text-muted">(D3)</small>
                </label>
                <p class="m-0" v-if="sector">
                  {{ sector.d_t3_code }}
                </p>
                <p class="m-0" v-else>N/A</p>
              </div>
              <div class="col-lg-3">
                <label for="">
                  Location <small class="text-muted">(D4)</small>
                </label>
                <p class="m-0" v-if="location">
                  {{ location.l_t6_code }}
                </p>
                <p class="m-0" v-else>N/A</p>
              </div>
              <div class="col-lg-3">
                <label for="">
                  Country Code <small class="text-muted">(D5)</small>
                </label>
                <p class="m-0" v-if="countryCode">
                  {{ countryCode.cc_code }}
                </p>
                <p class="m-0" v-else>N/A</p>
              </div>
              <div class="col-lg-3">
                <label for="">
                  Sector Name <small class="text-muted">(D6)</small>
                </label>
                <p class="m-0" v-if="sector">
                  {{ sector.department_name }}
                </p>
                <p class="m-0" v-else>N/A</p>
              </div>
            </div>

            <div
              class="row mb-4"
              v-if="application && application.travelapp_travel_cat === 1"
            >
              <div class="col-lg-6 mb-2">
                <label for="">Staff Travellers</label>
                <div
                  class="row mb-2"
                  v-for="(traveller, index) in staffTravellers"
                  :key="index"
                >
                  <div class="col-lg-1">
                    <label for="">S/n</label>
                    <p class="m-0">{{ index + 1 }}</p>
                  </div>
                  <div class="col-lg-3">
                    <label for="">Staff ID</label>
                    <p class="m-0">{{ traveller.ta_traveller_t7 }}</p>
                  </div>
                  <div class="col-lg-4">
                    <label for="">Name</label>
                    <p class="m-0">{{ traveller.ta_traveller_name }}</p>
                  </div>
                  <div class="col-lg-4">
                    <label for="">Phone</label>
                    <p class="m-0">{{ traveller.ta_traveller_phone }}</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <label for="">Non-Staff Travellers</label>
                <div
                  class="row mb-2"
                  v-for="(traveller, index) in nonStaffTravellers"
                  :key="index"
                >
                  <div class="col-lg-1">
                    <label for="">S/n</label>
                    <p class="m-0">{{ index + 1 }}</p>
                  </div>
                  <div class="col-lg-6">
                    <label for="">Name</label>
                    <p class="m-0">{{ traveller.ta_traveller_name }}</p>
                  </div>
                  <div class="col-lg-5">
                    <label for="">Phone</label>
                    <p class="m-0">{{ traveller.ta_traveller_phone }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <b-table-simple striped responsive bordered outlined>
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th>DEPART FROM</b-th>
                      <b-th>DATE</b-th>
                      <b-th>AIR/ROAD</b-th>
                      <b-th>AM/PM</b-th>
                      <b-th>DESTINATION</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(breakdown, index) in breakdowns" :key="index">
                      <b-td style="width: 30%">
                        <span>
                          {{ breakdown.ta_breakdown_from }}
                        </span>
                      </b-td>
                      <b-td style="width: 15%">
                        <span>
                          {{
                            new Date(breakdown.ta_breakdown_date).toDateString()
                          }}
                        </span>
                      </b-td>
                      <b-td style="width: 10%">
                        <span v-if="breakdown.ta_breakdown_mode === 1">
                          Road
                        </span>
                        <span v-else> Air </span>
                      </b-td>
                      <b-td style="width: 10%">
                        <span v-if="breakdown.ta_breakdown_prompt === 1">
                          AM
                        </span>
                        <span v-else> PM </span>
                      </b-td>
                      <b-td style="width: 30%">
                        <span>
                          {{ breakdown.ta_breakdown_destination }}
                        </span>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
            <div class="row mt-4" v-if="application.travelapp_travel_cat === 1">
              <div class="col-12">
                <b-table-simple responsive bordered outlined>
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th>PER DIEM RATE</b-th>
                      <b-th>NO. DAYS</b-th>
                      <b-th>CURRENCY</b-th>
                      <b-th class="text-center">TOTAL</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr>
                      <b-td style="width: 30%">
                        <span>
                          {{ application.travelapp_per_diem.toLocaleString() }}
                        </span>
                      </b-td>
                      <b-td style="width: 20%">
                        <span>
                          {{ application.travelapp_days.toLocaleString() }}
                        </span>
                      </b-td>
                      <b-td style="cursor: pointer; width: 20%">
                        <span> {{ application.travelapp_currency }} </span>
                      </b-td>
                      <b-td style="width: 30%; text-align: center">
                        {{ application.travelapp_total.toLocaleString() }}
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-lg-3">
                <label>Hotel Required?</label>
                <p class="m-0" v-if="application.travelapp_hotel === 1">YES</p>
                <p class="m-0" v-else>NO</p>
              </div>
            </div>

            <div class="row mt-4" v-if="application.travelapp_hotel === 1">
              <div class="col-12">
                <b-table-simple responsive bordered outlined>
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th>HOTEL NAME</b-th>
                      <b-th>CITY</b-th>
                      <b-th>COUNTRY</b-th>
                      <b-th>ARRIVAL DATE</b-th>
                      <b-th>DEPARTURE DATE</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(hotel, index) in hotels" :key="index">
                      <b-td>
                        <span>{{ hotel.ta_hotel_name }}</span>
                      </b-td>
                      <b-td>
                        <span>{{ hotel.ta_hotel_city }}</span>
                      </b-td>
                      <b-td>
                        <span>{{ hotel.ta_hotel_country }}</span>
                      </b-td>
                      <b-td>
                        <span>
                          {{
                            new Date(hotel.ta_hotel_arrival_date).toDateString()
                          }}
                        </span>
                      </b-td>
                      <b-td>
                        <span>
                          {{
                            new Date(
                              hotel.ta_hotel_departure_date
                            ).toDateString()
                          }}
                        </span>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>

            <div
              class="row my-4"
              v-if="application && application.travelapp_travel_cat === 1"
            >
              <div class="col-lg-12">
                <label>Attachments</label>
                <b-table-simple responsive bordered outlined hover>
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th>FILE NAME</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(attachment, index) in attachments"
                      :key="index"
                      @click="viewAttachment(attachment)"
                    >
                      <b-td>
                        <span>{{ attachment.ta_attachment_filename }}</span>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-4">
          <div class="card-body">
            <div class="p-3 bg-light mb-4 d-flex justify-content-between">
              <div class="d-inline mb-0">
                <h5 class="font-size-14 mb-0">Authorization Log</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-table-simple striped responsive bordered outlined>
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th>OFFICER</b-th>
                      <b-th>STATUS</b-th>
                      <b-th>COMMENT</b-th>
                      <b-th>DATE</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(logEntry, index) in log" :key="index">
                      <b-td style="width: 25%">
                        <span>
                          {{ logEntry.officers.emp_first_name }}
                          {{ logEntry.officers.emp_last_name }}
                        </span>
                      </b-td>
                      <b-td style="width: 15%">
                        <span
                          v-if="logEntry.auth_status === 0"
                          class="text-warning"
                        >
                          Pending
                        </span>
                        <span
                          v-else-if="logEntry.auth_status === 1"
                          class="text-success"
                        >
                          Approved
                        </span>
                        <span
                          v-else-if="logEntry.auth_status === 2"
                          class="text-success"
                        >
                          Declined
                        </span>
                      </b-td>
                      <b-td style="width: 40%">
                        <span>
                          {{ logEntry.auth_comment }}
                        </span>
                      </b-td>
                      <b-td style="width: 20%">
                        <span>
                          {{ new Date(logEntry.updatedAt).toDateString() }}
                          {{
                            new Date(logEntry.updatedAt).toLocaleTimeString()
                          }}
                        </span>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="2500"
      filename="Travel Application"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="text-center">
          <img
            style="width: 10%"
            src="data:image/png;base64,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"
            class="mt-3 mb-3"
          />
          <h5 class="mb-1">Employee Travel Request</h5>
        </div>
        <div class="row">
          <div class="col-12" v-if="application">
            <div class="card">
              <div class="card-body">
                <div class="p-3 bg-light mb-4 d-flex justify-content-between">
                  <div class="d-inline mb-0">
                    <h5
                      class="font-size-14 mb-0"
                      v-if="
                        application && application.travelapp_travel_cat === 1
                      "
                    >
                      Official Travel Authorization / Per Diem Form
                    </h5>
                    <h5 class="font-size-14 mb-0" v-else>
                      Personal Travel Authorization
                    </h5>
                  </div>
                  <span class="d-inline mb-0">
                    <small
                      v-if="application && application.travelapp_status === 0"
                      class="text-warning"
                    >
                      Application Pending
                    </small>
                    <small
                      v-else-if="
                        application && application.travelapp_status === 1
                      "
                      class="text-success"
                    >
                      Application Approved
                    </small>
                    <small
                      v-else-if="
                        application && application.travelapp_status === 2
                      "
                      class="text-danger"
                    >
                      Application Declined
                    </small>
                  </span>
                </div>
                <div class="row">
                  <div class="col-lg-8">
                    <div class="form-group">
                      <label for="">
                        Purpose of Travel
                        <small class="text-muted">(Description)</small>
                      </label>
                      <p class="text-muted">
                        {{ application.travelapp_purpose }}
                      </p>
                    </div>
                    <div class="form-group">
                      <label for="">
                        Dates of Travel
                        <small class="text-muted">(TO & FRO)</small>
                      </label>
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="form-group">
                            <label for=""> Start </label>
                            <p class="text-muted">
                              {{
                                new Date(
                                  application.travelapp_start_date
                                ).toDateString()
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group">
                            <label for=""> End </label>
                            <p class="text-muted">
                              {{
                                new Date(
                                  application.travelapp_end_date
                                ).toDateString()
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div
                      class="form-group"
                      v-if="
                        application && application.travelapp_travel_cat === 1
                      "
                    >
                      <label for="">Program / Charge Codes</label>
                      <div class="row">
                        <div class="col-lg-4">
                          <div class="form-group">
                            <label class="" for="">
                              T1
                              <small class="text-muted">(Grant Code)</small>
                            </label>
                          </div>
                        </div>
                        <div class="col-lg-8">
                          <div class="form-group">
                            <span>
                              <!--                          {{ donor.donor_code }} ({{ donor.donor_description }})-->
                              {{ application.travelapp_t1_code }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-if="expenses.length">
                        <div class="row">
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label for="">
                                T2 <small class="text-muted">(Expense)</small>
                              </label>
                            </div>
                          </div>
                          <div class="col-lg-8">
                            <div class="form-group">
                              <p
                                class="mb-0"
                                v-for="(t2code, index) in expenses"
                                :key="index"
                              >
                                <!--                            {{ t2code.expense }}: {{ t2code.code }}-->
                                {{ t2code.travelapp_t2_id }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row mb-4"
                  v-if="application && application.travelapp_travel_cat === 1"
                >
                  <div class="col-lg-12 mb-3">
                    <label for="">Trip Type</label>
                    <p class="m-0 text-uppercase">
                      {{ application.travelapp_trip_type }}
                    </p>
                  </div>
                  <div class="col-lg-3">
                    <label for="">
                      Sector Code <small class="text-muted">(D3)</small>
                    </label>
                    <p class="m-0" v-if="sector">
                      {{ sector.d_t3_code }}
                    </p>
                  </div>
                  <div class="col-lg-3">
                    <label for="">
                      Location <small class="text-muted">(D4)</small>
                    </label>
                    <p class="m-0" v-if="location">
                      {{ location.l_t6_code }}
                    </p>
                  </div>
                  <div class="col-lg-3">
                    <label for="">
                      Country Code <small class="text-muted">(D5)</small>
                    </label>
                    <p class="m-0" v-if="countryCode">
                      {{ countryCode.cc_code }}
                    </p>
                  </div>
                  <div class="col-lg-3">
                    <label for="">
                      Sector Name <small class="text-muted">(D6)</small>
                    </label>
                    <p class="m-0" v-if="sector">
                      {{ sector.department_name }}
                    </p>
                  </div>
                </div>
                <div
                  class="row mb-4"
                  v-if="application && application.travelapp_travel_cat === 1"
                >
                  <div class="col-lg-6 mb-2">
                    <label for="">Staff Travellers</label>
                    <div
                      class="row mb-2"
                      v-for="(traveller, index) in staffTravellers"
                      :key="index"
                    >
                      <div class="col-lg-1">
                        <label for="">S/n</label>
                        <p class="m-0">{{ index + 1 }}</p>
                      </div>
                      <div class="col-lg-3">
                        <label for="">Staff ID</label>
                        <p class="m-0">{{ traveller.ta_traveller_t7 }}</p>
                      </div>
                      <div class="col-lg-4">
                        <label for="">Name</label>
                        <p class="m-0">{{ traveller.ta_traveller_name }}</p>
                      </div>
                      <div class="col-lg-4">
                        <label for="">Phone</label>
                        <p class="m-0">{{ traveller.ta_traveller_phone }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 mb-2">
                    <label for="">Non-Staff Travellers</label>
                    <div
                      class="row mb-2"
                      v-for="(traveller, index) in nonStaffTravellers"
                      :key="index"
                    >
                      <div class="col-lg-1">
                        <label for="">S/n</label>
                        <p class="m-0">{{ index + 1 }}</p>
                      </div>
                      <div class="col-lg-6">
                        <label for="">Name</label>
                        <p class="m-0">{{ traveller.ta_traveller_name }}</p>
                      </div>
                      <div class="col-lg-5">
                        <label for="">Phone</label>
                        <p class="m-0">{{ traveller.ta_traveller_phone }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <b-table-simple striped responsive bordered outlined>
                      <b-thead head-variant="light">
                        <b-tr>
                          <b-th>DEPART FROM</b-th>
                          <b-th>DATE</b-th>
                          <b-th>AIR/ROAD</b-th>
                          <b-th>AM/PM</b-th>
                          <b-th>DESTINATION</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr
                          v-for="(breakdown, index) in breakdowns"
                          :key="index"
                        >
                          <b-td style="width: 30%">
                            <span>
                              {{ breakdown.ta_breakdown_from }}
                            </span>
                          </b-td>
                          <b-td style="width: 15%">
                            <span>
                              {{
                                new Date(
                                  breakdown.ta_breakdown_date
                                ).toDateString()
                              }}
                            </span>
                          </b-td>
                          <b-td style="width: 10%">
                            <span v-if="breakdown.ta_breakdown_mode === 1">
                              Road
                            </span>
                            <span v-else> Air </span>
                          </b-td>
                          <b-td style="width: 10%">
                            <span v-if="breakdown.ta_breakdown_prompt === 1">
                              AM
                            </span>
                            <span v-else> PM </span>
                          </b-td>
                          <b-td style="width: 30%">
                            <span>
                              {{ breakdown.ta_breakdown_destination }}
                            </span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
                <div
                  class="row mt-4"
                  v-if="application.travelapp_travel_cat === 1"
                >
                  <div class="col-12">
                    <b-table-simple responsive bordered outlined>
                      <b-thead head-variant="light">
                        <b-tr>
                          <b-th>PER DIEM RATE</b-th>
                          <b-th>NO. DAYS</b-th>
                          <b-th>CURRENCY</b-th>
                          <b-th class="text-center">TOTAL</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr>
                          <b-td style="width: 30%">
                            <span>
                              {{
                                application.travelapp_per_diem.toLocaleString()
                              }}
                            </span>
                          </b-td>
                          <b-td style="width: 20%">
                            <span>
                              {{ application.travelapp_days.toLocaleString() }}
                            </span>
                          </b-td>
                          <b-td style="cursor: pointer; width: 20%">
                            <span> {{ application.travelapp_currency }} </span>
                          </b-td>
                          <b-td style="width: 30%; text-align: center">
                            {{ application.travelapp_total.toLocaleString() }}
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-lg-3">
                    <label>Hotel Required?</label>
                    <p class="m-0" v-if="application.travelapp_hotel === 1">
                      YES
                    </p>
                    <p class="m-0" v-else>NO</p>
                  </div>
                </div>

                <div class="row mt-4" v-if="application.travelapp_hotel === 1">
                  <div class="col-12">
                    <b-table-simple responsive bordered outlined>
                      <b-thead head-variant="light">
                        <b-tr>
                          <b-th>HOTEL NAME</b-th>
                          <b-th>CITY</b-th>
                          <b-th>COUNTRY</b-th>
                          <b-th>ARRIVAL DATE</b-th>
                          <b-th>DEPARTURE DATE</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="(hotel, index) in hotels" :key="index">
                          <b-td>
                            <span>{{ hotel.ta_hotel_name }}</span>
                          </b-td>
                          <b-td>
                            <span>{{ hotel.ta_hotel_city }}</span>
                          </b-td>
                          <b-td>
                            <span>{{ hotel.ta_hotel_country }}</span>
                          </b-td>
                          <b-td>
                            <span>
                              {{
                                new Date(
                                  hotel.ta_hotel_arrival_date
                                ).toDateString()
                              }}
                            </span>
                          </b-td>
                          <b-td>
                            <span>
                              {{
                                new Date(
                                  hotel.ta_hotel_departure_date
                                ).toDateString()
                              }}
                            </span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mt-4">
              <div class="card-body">
                <div class="p-3 bg-light mb-4 d-flex justify-content-between">
                  <div class="d-inline mb-0">
                    <h5 class="font-size-14 mb-0">Authorization Log</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-table-simple striped responsive bordered outlined>
                      <b-thead head-variant="light">
                        <b-tr>
                          <b-th>OFFICER</b-th>
                          <b-th>STATUS</b-th>
                          <b-th>COMMENT</b-th>
                          <b-th>DATE</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="(logEntry, index) in log" :key="index">
                          <b-td style="width: 25%">
                            <span>
                              {{ logEntry.officers.emp_first_name }}
                              {{ logEntry.officers.emp_last_name }}
                            </span>
                          </b-td>
                          <b-td style="width: 15%">
                            <span
                              v-if="logEntry.auth_status === 0"
                              class="text-warning"
                            >
                              Pending
                            </span>
                            <span
                              v-else-if="logEntry.auth_status === 1"
                              class="text-success"
                            >
                              Approved
                            </span>
                            <span
                              v-else-if="logEntry.auth_status === 2"
                              class="text-success"
                            >
                              Declined
                            </span>
                          </b-td>
                          <b-td style="width: 40%">
                            <span>
                              {{ logEntry.auth_comment }}
                            </span>
                          </b-td>
                          <b-td style="width: 20%">
                            <span>
                              {{ new Date(logEntry.updatedAt).toDateString() }}
                              {{
                                new Date(
                                  logEntry.updatedAt
                                ).toLocaleTimeString()
                              }}
                            </span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </VueHtml2pdf>
  </Layout>
</template>
